import { getIdentityLoginUrl } from '@atlassian/pillar/runtime/env';

const CLIENT_AUTH_REDIRECT_COUNT_STORAGE_KEY = 'dtac.auth.redirect-count';

/**
 * Maximum number of times the user will be redirected to the auth page before instead
 * showing a login failed error.
 */
const MAX_REDIRECT_COUNT = 1;

function getRedirectCount(): number {
	// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
	const count = globalThis.window.sessionStorage.getItem(CLIENT_AUTH_REDIRECT_COUNT_STORAGE_KEY);
	return count ? parseInt(count, 10) : 0;
}

export function hasAutomaticAuthFailed(): boolean {
	return getRedirectCount() > MAX_REDIRECT_COUNT;
}

export function attemptClientLogin(): void {
	const newRedirectCount = getRedirectCount() + 1;
	// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
	globalThis.window.sessionStorage.setItem(
		CLIENT_AUTH_REDIRECT_COUNT_STORAGE_KEY,
		newRedirectCount.toString(),
	);

	globalThis.window.location.replace(getIdentityLoginUrl());
}

export function cleanupClientAuthFlow(): void {
	// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
	globalThis.window.sessionStorage.removeItem(CLIENT_AUTH_REDIRECT_COUNT_STORAGE_KEY);
}
